import type * as Blockly from 'blockly/core';
import { BOARD_CONFIG } from '@/(routers)/boards/editor/block/blockConfig';
import { registerSetupCode, resolveBoard, stmt } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

type Position = keyof (typeof BOARD_CONFIG)[keyof typeof BOARD_CONFIG]['pins'];

export function register(gen: any): void {
    gen.forBlock['tt_motor'] = function (block: Blockly.Block): string {
        const position = block.getFieldValue('POSITION') as Position;
        const state = block.getFieldValue('STATE') as 'FORWARD' | 'REVERSE' | 'STOP';
        const board = resolveBoard(block);
        const pins = BOARD_CONFIG[board].pins[position];
        const first = pins.first;
        const second = pins.second;

        registerSetupCode(String(first), `  pinMode(${first}, OUTPUT);\n`);
        registerSetupCode(String(second), `  pinMode(${second}, OUTPUT);\n`);

        const [firstVal, secondVal] = {
            FORWARD: ['HIGH', 'LOW'],
            REVERSE: ['LOW', 'HIGH'],
            STOP: ['HIGH', 'HIGH'],
        }[state];

        return stmt(`digitalWrite(${first}, ${firstVal})`) + stmt(`digitalWrite(${second}, ${secondVal})`);
    };
}
